var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06226 25.8952V4.70768C7.06226 4.08332 7.31028 3.48453 7.75178 3.04303C8.19327 2.60154 8.79206 2.35352 9.41642 2.35352H18.8331C19.4575 2.35352 20.0562 2.60154 20.4977 3.04303C20.9392 3.48453 21.1873 4.08332 21.1873 4.70768V25.8952H7.06226Z",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06258 14.127H4.70841C4.08405 14.127 3.48526 14.375 3.04377 14.8165C2.60228 15.258 2.35425 15.8568 2.35425 16.4811V23.5436C2.35425 24.168 2.60228 24.7668 3.04377 25.2083C3.48526 25.6498 4.08405 25.8978 4.70841 25.8978H7.06258",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 10.5938H23.5417C24.166 10.5938 24.7648 10.8418 25.2063 11.2833C25.6478 11.7248 25.8958 12.3236 25.8958 12.9479V23.5417C25.8958 24.166 25.6478 24.7648 25.2063 25.2063C24.7648 25.6478 24.166 25.8958 23.5417 25.8958H21.1875",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7705 7.0625H16.4788",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7705 11.7734H16.4788",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7705 16.4766H16.4788",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7705 21.1895H16.4788",
    stroke: "white",
    strokeWidth: 2.35417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2B);
export default __webpack_public_path__ + "static/media/b2b.89c30cb3311c17a0b71e6a5bd17dd159.svg";
export { ForwardRef as ReactComponent };